import isEmpty from 'lodash/isEmpty';
import {
    seoUrlEvent,
    seoUrlInplayEvent,
    seoUrlSport,
    seoUrlTournamentOutrights,
} from '~spa/Utils/SeoUrls.js';
import i18n from '~shared/utils/i18n';
import { ODDS_BOOST_SLUG } from '~shared/utils/constants';

export const generateEventUrl = (event) => {
    const {
        sport_slug: sportSlug,
        category_slug: categorySlug,
        tournament_slug,
        sport_l10n_slug,
        category_l10n_slug,
        tournament_l10n_slug,
        event_l10n_slug,
        id: eventId,
        slug: eventSlug,
        event_type,
        is_inplay,
        sport_id,
        tournament_id,
    } = event;

    let eventUrl = '';

    const isOutright = event_type.toLowerCase() === 'outright';

    if (sportSlug === ODDS_BOOST_SLUG) {
        // direct to odds-boost page instead of sport page if it's odds-boost card.
        eventUrl = seoUrlSport(i18n.t('url.odds-boost'), sport_id);
    } else if (isOutright) {
        const outrightUrl = [
            sport_l10n_slug || sportSlug,
            category_l10n_slug || categorySlug,
            tournament_l10n_slug || tournament_slug,
            i18n.t('url.outrights'),
        ].join('/');

        eventUrl = seoUrlTournamentOutrights(outrightUrl, tournament_id);
    } else if (is_inplay) {
        const inplayUrl = `${i18n.t('url.inplay_homepage')}/${i18n.t('url.inplay_event')}`;

        eventUrl = seoUrlInplayEvent(`${inplayUrl}/${eventId}`, eventId);
    } else {
        eventUrl = seoUrlEvent([
            sport_l10n_slug || sportSlug,
            category_l10n_slug || categorySlug,
            tournament_l10n_slug || tournament_slug,
            event_l10n_slug || eventSlug,
        ].join('/'), eventId);
    }

    return eventUrl;
};

export const getSelectionsData = (betcard, commonDataEvents, gtmAttribute) => {
    const selections = betcard.selection_pointers.map(selectionPointer => {
        const {event_id, market_id, selection_id} = selectionPointer;
        const event = {...commonDataEvents[event_id]};

        if (isEmpty(event)) {
            return null;
        }

        const {
            sport_slug: sportSlug,
            category_slug: categorySlug,
            scheduled_start: scheduledStart,
            name,
            tournament_logos: tournamentLogos,
            is_inplay: isInplay,
            betable: eventBetable,
            is_outright,
            tournament_name,
        } = event;

        const eventName = is_outright ? tournament_name : name;

        const market = event.markets[market_id];

        const {
            name: selectionName,
            active,
            betable: selectionBetable,
            decimal_price: decimalPrice,
            fraction_price: fractionPrice,
            american_price: americanPrice,
            team_slug: teamSlug,
            extra_info: extraInfo,
            sp_only: spOnly,
        } = market.selections[selection_id];

        const eventUrl = generateEventUrl(event);

        return {
            selectionId: String(selection_id),
            selectionName,
            eventName,
            marketName: market.name,
            sportSlug,
            scheduledStart,
            eventUrl,
            active,
            tradable: decimalPrice && selectionBetable,
            betable: eventBetable && selectionBetable,
            tournamentLogos,
            decimalPrice,
            fractionPrice,
            americanPrice,
            teamSlug,
            extraInfo,
            spOnly,
            categorySlug,
            gtmAttribute: `${gtmAttribute};`,
            isInplay,
        };

    });

    return selections.filter(Boolean);
};
